import { push } from 'connected-react-router';
import { userManager } from '../../utils/userManager';
import { LOGOUT, LOGIN_FAILURE, LOGIN_START, LOGIN_SILENT } from '../constants/types';

import axios from '../../utils/axios';

const userLoggedIn = async jwtToken => {
  try {
    await axios.post(
      'v1/command/UserLoggedIn',
      {},
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      },
    );
  } catch (err) {
    // ignore errors
  }
};

const userLoggedOut = async jwtToken => {
  try {
    await axios.post(
      'v1/command/UserLoggedOut',
      {},
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      },
    );
  } catch (err) {
    // ignore errors
  }
};

const callback = jwtToken => dispatch => {
  dispatch({
    type: LOGIN_START,
  });

  userLoggedIn(jwtToken);
  dispatch(push('/'));
};

const error = message => dispatch => {
  dispatch({
    type: LOGIN_FAILURE,
    ...message,
  });
  dispatch(push('/'));
};

const silent = () => dispatch => {
  dispatch({
    type: LOGIN_SILENT,
  });
};

const logoutFromOidc = message => (dispatch, getState) => {
  const currentState = getState();

  userLoggedOut(currentState.global.auth.jwtToken);

  dispatch({
    type: LOGOUT,
    ...message,
  });

  userManager.getUser().then(user => {
    if (user) {
      userManager.signoutRedirect();
    } else {
      dispatch(push('/'));
    }
  });
};

const logoutAndRedirect = message => dispatch => dispatch(logoutFromOidc(message));

export { error, silent, callback, logoutAndRedirect };
